import { html, View } from 'rune-ts';
import { typo } from '../../../../../services/MarppleShop/shared/typography/typo';
import klass from './MembershipSettingForm.module.scss';
import { MultiSelectButtonGroup } from '../../../../../services/MarppleShop/renderApp/components/cells/MultiSelectButtonGroup/MultiSelectButtonGroup';
import { map, pipe, toArray } from '@fxts/core';
import {
  MEMBERSHIP_STATE,
  PartialMembership,
} from '../../../../../services/MarppleShop/features/Membership/type';
import { UtilS } from '../../../../Util/S/Function/module/UtilS';
import { initTooltips2 } from '../../../../Util/F/tooltip';
import { Tooltip } from '@services/MarppleShop/renderApp/components/atoms/Tooltip/Tooltip.ts';
import { shareFont } from '@services/MarppleShop/shared/typography';

interface Membership {
  id: string;
  name: string;
}

export interface MembershipSettingSectionData {
  memberships: (PartialMembership & { selected: boolean })[];
}

interface MembershipSettingSectionOption {
  klass?: string;
  group_klass?: string;
}

export class MembershipSettingSection extends View<Readonly<MembershipSettingSectionData>> {
  private readonly MultiSelectButtonGroupView: MultiSelectButtonGroup;

  constructor(
    data: Readonly<MembershipSettingSectionData>,
    private option: MembershipSettingSectionOption = {},
  ) {
    super(data, option);

    const datas = pipe(
      this.data.memberships,
      map((membership) => ({
        ...membership,
        name: this.makeMembershipDisplayName(membership),
      })),
      toArray,
    );
    this.MultiSelectButtonGroupView = new MultiSelectButtonGroup(datas, { klass: this.option?.group_klass });
  }

  override onRender() {
    initTooltips2({
      container_el: this.element(),
      custom: {
        maxWidth: 343,
        animation: 'shift-toward',
        duration: 300,
      },
    });
  }

  override template() {
    const localized_text = this.getLocalizedText();

    if (!this.isSectionVisible()) {
      return html`<section></section>`;
    }

    return html`<section class="${klass.membership_setting_section} ${this.option.klass ?? ''}">
      <div class="${klass.title_container}">
        <span class="${typo('14_bold')}">${localized_text.title}</span>
        ${new Tooltip({
          id: 'membership_ids',
          content: html`
            <div class="${shareFont('14_medium')}">
              ${html.preventEscape(UtilS.escape(localized_text.tooltip_content, true))}
            </div>
          `,
          size: 'x_small',
          variant: 'studio',
        })}
      </div>
      ${this.MultiSelectButtonGroupView}
    </section>`;
  }

  private getLocalizedText() {
    return {
      title: ET('mps2::seller_studio::membership_setting::title'),
      tooltip_content: ET('mps2::seller_studio::membership_setting::tooltip_content'),
      private: ET('mps2::seller_studio::membership_setting::private'),
    };
  }

  private isSectionVisible(): boolean {
    return this.data.memberships.length > 0;
  }

  private makeMembershipDisplayName({
    state,
    displayName,
  }: Pick<PartialMembership, 'state' | 'displayName'>) {
    if (state === MEMBERSHIP_STATE.HIDDEN) {
      return `${displayName} (${this.getLocalizedText().private})`;
    } else {
      return displayName;
    }
  }

  getSelectedMembershipIds(): Membership['id'][] {
    return this.MultiSelectButtonGroupView.getSelectedIds();
  }

  hasChanged(): boolean {
    return this.MultiSelectButtonGroupView.hasChanged();
  }
}
